
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { format, startOfMonth, subDays } from 'date-fns';

import SubmitButton from '@/components/controls/submit-button.vue';
import FormInput from '@/components/controls/form-input.vue';
import SelectInput from '@/components/controls/select-input.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import { SendGridEmailType } from '@/store/modules/sendgrid_emails/types';

const toISODate = (date: Date): string => format(date, 'yyyy-MM-dd');

export default Vue.extend({
  name: 'EmailsFilterForm',
  components: {
    SubmitButton,
    FormInput,
    SelectInput,
    Dropdown,
  },
  data() {
    return {
      SendGridEmailType,
      search: '',
      emailType: '',
      status: '',
      interval: '',
      from: '',
      to: '',
    };
  },
  computed: {
    ...mapGetters('sendgrid_emails', ['isLoading']),
    dropdownItems(): DropdownItems {
      return {
        reset: {
          label: this.$t('Reset Filters'),
          icon: 'close',
        },
      };
    },
  },
  methods: {
    initFilters(): void {
      const query = this.$router.currentRoute.query;
      this.search = (query.search as string) || '';
      this.emailType = (query.email_type as string) || '';
      this.status = (query.status as string) || '';
      this.interval = (query.interval as string) || '';
      this.from = (query.from as string) || '';
      this.to = (query.to as string) || '';
    },
    resolvedRange(): { from?: string; to?: string } {
      const today = new Date();

      switch (this.interval) {
        case 'month':
          return { from: toISODate(startOfMonth(today)), to: toISODate(today) };
        case '7':
          return { from: toISODate(subDays(today, 6)), to: toISODate(today) };
        case '30':
          return { from: toISODate(subDays(today, 29)), to: toISODate(today) };
        case 'custom':
          return { from: this.from || undefined, to: this.to || undefined };
        default:
          return {};
      }
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;
      const range = this.resolvedRange();

      this.$router.push({
        params: {
          page: 1,
        },
        query: {
          ...queryParams,
          search: this.search || undefined,
          email_type: this.emailType || undefined,
          status: this.status || undefined,
          interval: this.interval || undefined,
          from: range.from,
          to: range.to,
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: 1,
          },
          query: {},
        });
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
